import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Channel, StreamChat } from 'stream-chat';
import { ChatClientService, ChannelService, StreamI18nService } from 'stream-chat-angular';
import { StreamChatService } from './stream-chat.service';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import { finalize } from 'rxjs';
import { UserService } from 'app/core/user/user.service';
import { marked } from 'marked';
import { DomSanitizer } from '@angular/platform-browser';

export interface Message {
  value: string;
  isMine: boolean;
  createdAt: Date;
}

@Component({
  selector: 'chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class ChatComponent implements OnInit  {

  @Input() currentUser: any;

  isTyping = false;
  chat: { messages: Message[] } = {
    messages: [
     
    ]
  };

  faRobot = faRobot;
  @ViewChild('messageInput') messageInput: ElementRef;

  constructor(private formBuilder: FormBuilder, private _chatService: StreamChatService, private _userService: UserService,     private sanitizer: DomSanitizer ) { }

  ngOnInit(): void {
      this.messageInput.nativeElement.focus();
  }

  public active: boolean = false;
  public chatForm: FormGroup = this.formBuilder.group({
    userInput: ""
  });

  public toggleChat(): void {
    this.active = !this.active;
  }

  public closeChat(): void {
    this.active = false;
  }

  sendMessage(event) {
    event.preventDefault();
    const userInput = this.messageInput.nativeElement.value;

    // Add user input message
    this.chat.messages.push(
      { value: this.convertMarkdownToHtml(userInput), isMine: true, createdAt: new Date() },
    );

    // Clear input field
    this.messageInput.nativeElement.value = '';
    this.messageInput.nativeElement.focus();

    this.isTyping = true;

    let body = {
      prompt: userInput,
      user: this.currentUser.email,
      stream: false
    };

    // Request answer from the service
    this._chatService.getAnswer(body)
      .pipe(finalize(() => {
        this.isTyping = false;
      }))
      .subscribe(response => {
        // Add AI response
        this.chat.messages.push(
          { value: this.convertMarkdownToHtml(response.response || response.detail), isMine: false, createdAt: new Date() },
        );
      }, (error) => {
        console.log(error);
        if (error.status == 0) {
          this.chat.messages.push(
            { value: "Something wrong happended during request handle, try again later!", isMine: false, createdAt: new Date() },
          );
        }
        else {
          this.chat.messages.push(
            { value: this.convertMarkdownToHtml(error.error.detail), isMine: false, createdAt: new Date() },
          );
        }
        
      });
  }

  // Convert Markdown to HTML and sanitize the result
  convertMarkdownToHtml(markdownText: string): string {
    const htmlContent = marked(markdownText).toString(); // Convert Markdown to HTML
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent) as string; // Sanitize HTML content
  }
}
